import { NumberFormat } from './number-format';

export function getStatusNameByStatusCode(
    code: number,
    classify_cancel: number,
): string {
    let result: string = '';
    switch (code) {
        case 0: {
            if (classify_cancel === 0) {
                result = 'Khách hủy';
            } else if (classify_cancel === 1) {
                result = 'T.xế hủy';
            } else {
                result = 'Đã hủy';
            }
            break;
        }
        case 1: {
            result = 'Chờ giá';
            break;
        }
        case 2: {
            result = 'Đã nhận';
            break;
        }
        case 3: {
            result = 'Chờ đón';
            break;
        }
        case 4: {
            result = 'Đã đón';
            break;
        }
        case 5: {
            result = 'Đang đi';
            break;
        }
        case 6: {
            result = 'Hoàn thành';
            break;
        }
        case 7: {
            result = 'Chờ x.nhận';
            break;
        }
        case 99: {
            result = 'Không nhận';
            break;
        }
    }
    return result;
}

export function getSeverity(code: number) {
    switch (code) {
        case 0:
            return 'danger';

        case 1:
            return 'info';

        case 2:
            return 'help';

        case 3:
            return 'warning';

        case 4:
            return 'secondary';

        case 5:
            return 'contrast';

        case 6:
            return 'success';

        case 7:
            return 'secondary';

        case 8:
            return 'primary';
        default:
            return null;
    }
}

export function formatNumber(value) {
    if (!value) {
        return '0';
    }
    const outputString = value.toString().split('.');
    outputString[0] = NumberFormat.changeFormatNumber(
        outputString[0],
        ',',
        '.',
    );
    return outputString.join(',');
}
